import gql from 'graphql-tag';

export const mutationDeleteDokkioTag = gql`
  mutation deleteDokkioTag (
    $id: DokkioID!
  ) {
    deleteDokkioTag (
      id: $id
    )
  }
`;
export default mutationDeleteDokkioTag;
